// layouts/PublicLayout.jsx
import React from 'react';
import { useNavigate, useLocation, Link } from 'react-router-dom';
import { Bus, Search, Ticket, ArrowLeft } from 'lucide-react';

const PublicLayout = ({ children }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const showBackButton = location.pathname !== '/';
  const estaEnBuscarReserva = location.pathname === '/buscar-reserva';

  return (
    <div className="min-h-screen bg-gradient-to-br from-pink-50 to-white flex flex-col">
      {/* Header */}
      <header className="bg-white border-b-2 border-[#e83e8c] shadow-sm sticky top-0 z-20">
        <div className="container mx-auto px-4 py-3">
          <div className="flex items-center justify-between gap-3">
            {/* ✅ Botón volver mejorado */}
            <div className="flex-shrink-0">
              {showBackButton ? (
                <button
                  onClick={() => navigate(-1)}
                  className="group flex items-center gap-2 px-3 sm:px-4 py-2 rounded-xl text-sm font-medium
                             text-gray-600 bg-white hover:bg-gray-50
                             border border-gray-200 hover:border-[#e83e8c] hover:text-[#e83e8c]
                             transition-all duration-200 shadow-sm hover:shadow-md"
                  title="Volver a la página anterior"
                >
                  <ArrowLeft className="w-4 h-4 group-hover:-translate-x-1 transition-transform" />
                  <span className="hidden sm:inline whitespace-nowrap">Volver</span>
                </button>
              ) : (
                <div className="w-20"></div>
              )}
            </div>

            {/* Logo */}
            <div className="text-center flex-1 min-w-0">
              <div className="flex items-center justify-center gap-2">
                <div>
                  <h1 className="text-lg sm:text-xl tracking-wide">
                    <span className="text-[#e83e8c]">Transporte</span>{' '}
                    <span className="text-[#e83e8c] italic font-bold">
                      Tren al Sur
                    </span>
                  </h1>
                  <p className="text-xs text-gray-400 mt-0.5 hidden sm:block">
                    Tu viaje comienza aquí{' '}
                    <Bus className="inline-block w-4 h-4 text-[#e83e8c] align-text-bottom" />
                  </p>
                </div>
              </div>
            </div>

            {/* ✅ Botón destacado: Consultar reserva */}
            <div className="flex-shrink-0">
              <Link
                to="/buscar-reserva"
                className={`
                  group flex items-center gap-2 px-3 sm:px-4 py-2 rounded-xl text-sm font-medium
                  transition-all duration-200 shadow-sm
                  ${
                    estaEnBuscarReserva
                      ? 'bg-[#e83e8c] text-white shadow-md'
                      : 'bg-pink-50 text-[#e83e8c] hover:bg-[#e83e8c] hover:text-white hover:shadow-md'
                  }
                `}
                title="Consultar una reserva ya comprada"
              >
                <Ticket className="w-4 h-4" />
                <span className="hidden sm:inline whitespace-nowrap">
                  Consultar reserva
                </span>
              </Link>
            </div>
          </div>
        </div>
      </header>

      {/* Contenido principal */}
      <main className="flex-1">
        {children}
      </main>

      {/* Footer */}
      <footer className="bg-white border-t-2 border-[#e83e8c] mt-auto">
        <div className="container mx-auto px-4 py-6">
          <div className="text-center text-sm text-gray-400">
            © 2026 Transporte Tren al Sur - Todos los derechos reservados
          </div>
        </div>
      </footer>
    </div>
  );
};

export default PublicLayout;